function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M65.836 19.77c-2.496 0-4.617-2.375-4.617-5.29l.09 20.051c0 2.914 2.03 5.29 4.527 5.29h1.816c.5 0 .891-.481.891-1.044V19.77zm0 0",
  fill: "#ff7e00"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M63.984 0h-1.843a.91.91 0 00-.907.906v16.887a4.605 4.605 0 004.594 4.598h2.715l.035-11.258V4.578A4.585 4.585 0 0063.984 0zm0 0",
  fill: "#fbaf05"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M112.543 11.727a.909.909 0 00-.902.906v22.59a4.602 4.602 0 004.593 4.597h1.825a.91.91 0 00.906-.906v-22.57a4.602 4.602 0 00-4.594-4.598h-1.828zm0 0",
  fill: "#ff7e00"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M115.313 7.402A3.69 3.69 0 00119 3.711a3.69 3.69 0 10-7.379 0 3.691 3.691 0 003.692 3.691zm0 0",
  fill: "#fbaf05"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M28.23 32.488l-.02-1.754c0-.652-.07-1.285-.214-1.918-.562-2.554-.906-4.039-2.766-5.847a13.931 13.931 0 002.965-9.848A13.984 13.984 0 0015.335.254C7.16-.38.326 5.973.166 13.973v21.394a4.448 4.448 0 004.448 4.453h1.969a.91.91 0 00.906-.906V26.605c1.68.926 3.578 1.52 5.57 1.684 2.008.164 3.922-.11 5.696-.707.18.145.363.309.523.492.996.992 1.703 2.496 1.703 4.25 0 .094 0 .2.016.309v2.644a4.605 4.605 0 004.594 4.598h1.808a.904.904 0 00.907-.926zM7.543 14.68a6.677 6.677 0 017.086-7.098c3.312.219 6.008 2.898 6.223 6.227.253 4.02-3.055 7.351-7.09 7.097-3.309-.218-6.004-2.914-6.219-6.226zm0 0",
  fill: "#ff7e00"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.27.18C6.473.125.145 6.426.145 14.227a3.676 3.676 0 003.671 3.675 3.678 3.678 0 003.672-3.675h.035a6.663 6.663 0 016.657-6.66h.09V7.53a3.678 3.678 0 003.671-3.676A3.678 3.678 0 0014.27.18zm0 0M24.578 10.55a3.676 3.676 0 00-3.672 3.677h-.035a6.663 6.663 0 01-6.656 6.66h-.09v.035a3.676 3.676 0 000 7.351c7.793.051 14.125-6.246 14.125-14.046a3.678 3.678 0 00-3.672-3.676zm0 0",
  fill: "#fbaf05"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M54.184 11.258H52.34a.91.91 0 00-.906.906v1.246a14.157 14.157 0 00-7.704-1.683c-6.925.492-12.535 6.101-13.003 13.015-.579 8.2 5.933 15.059 14.015 15.059.762 0 1.485-.055 2.207-.18a3.191 3.191 0 002.676-3.152v-5.137c0-.363-.414-.582-.703-.344-1.848 1.465-4.469 1.989-7.129.832a6.165 6.165 0 01-3.164-3.203c-2.063-4.89 1.484-9.594 6.113-9.594 3.637 0 6.621 2.915 6.711 6.551v9.63a4.602 4.602 0 004.594 4.597h1.824a.91.91 0 00.906-.906v-7.727h.016V15.855c-.016-2.535-2.078-4.597-4.61-4.597zm0 0M94.676 11.258h-1.844a.91.91 0 00-.906.906v1.266a14.15 14.15 0 00-7.703-1.684c-6.926.488-12.535 6.102-13.004 13.016-.578 8.199 5.933 15.058 14.015 15.058.762 0 1.485-.054 2.207-.183a3.187 3.187 0 002.676-3.149v-5.14c0-.36-.414-.578-.703-.344-1.848 1.465-4.469 1.992-7.125.832a6.145 6.145 0 01-3.168-3.203c-2.058-4.887 1.484-9.594 6.113-9.594 3.637 0 6.621 2.914 6.711 6.555v9.629a4.605 4.605 0 004.594 4.597h1.809a.909.909 0 00.902-.906v-7.766h.02V15.836a4.585 4.585 0 00-4.594-4.578zm0 0M106.367 21.059c-2.555 0-4.547-2.493-4.547-5.223l-.09 19.035c0 2.727 2.082 4.95 4.637 4.95h1.863c.512 0 .915-.45.915-.977l-.024-17.785zm0 0",
  fill: "#ff7e00"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M104.531 0h-1.844a.91.91 0 00-.906.906v16.887c0 2.531 2.063 4.652 4.594 4.652h2.75V4.578A4.585 4.585 0 00104.531 0zm0 0",
  fill: "#fbaf05"
});

function SvgLogoRalaliDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 40
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default SvgLogoRalaliDefault;